<template lang="pug">
  v-card.reservation-calendar
    v-calendar(
      :events="events"
      :event-color="getEventColor"
      type="week"
      interval-count=15
      first-interval=8
      interval-height=48
      @click:event="showSlot"
      v-if="facilityIds.length"
    )
      template(v-slot:event="{event}")
        div
          div.px-1.font-weight-bold {{event.name}}
          div.px-1 {{timeSlotString(event)}}
    v-card-text(v-else) Select one or more facilities above to view available slots.
</template>

<script>
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState({
      facilityIds: state => state.main.facilityIds,
      pendingSessions: state => state.main.pendingSessions
    }),
    ...mapGetters([
      'isInTimingWindow',
      'selectedFacilitySlots',
      'slotOptions',
      'team',
      'registrationGroup'
    ]),
    selectedSlot: {
      get () {
        return this.$store.state.main.selectedSlot
      },
      set (value) {
        this.$store.commit('setSlot', value)
      }
    },
    tab: {
      get () {
        return this.$store.state.main.tab
      },
      set (value) {
        this.$store.commit('setTab', value)
      }
    },
    events () {
      let slots = this.slotOptions

      let events = Object.values(slots).map(({reservableFacilities, reservedBySelectedTeam, pendingReservation, pendingNowUnavailable, start, end, allowed}) => {
        let name, color
        if(pendingNowUnavailable){
          name = "No Longer Available"
          color = "#C62828"
        } else if(pendingReservation){
          name = "Pending"
          color = "#6A1B9A"
        } else if(reservedBySelectedTeam){
          name = "Reserved"
          color = "#2E7D32"
        } else if(reservableFacilities >= 1) {
          if(allowed && this.isInTimingWindow) {
            name = `Available`
            color = "#1565C0"
          } else {
            name = `Available`
            color = "#1976D2"
          }
        } else {
          name = "Unavailable"
          color = "#424242"
        }
        return { name, color, start, end}
      })

      // if there would be no events we need a dummy event
      // https://github.com/vuetifyjs/vuetify/issues/7790
      return events.length > 0 ? events : [{ start: "1900-01-01", name: "" }]
    }
  },
  methods: {
    getEventColor (event) {
      return event.color
    },
    showSlot ({event}) {
      this.tab=1
      this.selectedSlot = event
      this.$store.dispatch('lazyRefresh')
    },
    timeSlotString(event) {
      let start = moment(event.start)
      let end = moment(event.end)
      let startString = start.minutes() == 0 ? start.format('h') : start.format('h:mm')
      let endString = end.minutes() == 0 ? end.format('h a') : end.format('h:mm a')
      return `${startString}-${endString}`
    },
  }
}
</script>

<style lang="stylus">
.reservation-calendar
  .v-calendar-daily_head-day-label
    display:none
  .v-calendar-daily_head-day.v-past .v-calendar-daily_head-weekday
    color: #595959 !important
</style>